import { GameSpinsRemainingProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSpinsRemainingProperties";
/**
 * SpinsRemainingPortraitProperties.ts
 */
export class SpinsRemainingPortraitProperties extends GameSpinsRemainingProperties {
    constructor() {
        super();
        this.position.set(512, 1719);
    }
}
//# sourceMappingURL=SpinsRemainingPortraitProperties.js.map